const state = {
  show: false,
  showQuoteLoader: false
};

const getters = {
  show: state => state.show
};

let loaderStart;

const actions = {
  start({ commit }, buffer) {
    commit('updateState', { prop: 'text', value: '' });
    commit('updateState', { prop: 'showQuoteLoader', value: false });

    if (buffer === undefined) {
      buffer = 2000;
    }

    clearTimeout(loaderStart);

    loaderStart = setTimeout(function () {
      commit('updateState', { prop: 'show', value: true });
    }, buffer);
  },
  quoteLoader({ commit }) {
    commit('updateState', { prop: 'showQuoteLoader', value: true });
  },
  stop({ commit }) {
    clearTimeout(loaderStart);
    commit('updateState', { prop: 'show', value: false });
  }
};

const mutations = {
  updateState(state, { prop, value }) {
    state[prop] = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
